/**
 * /* eslint-disable react/jsx-props-no-spreading
 *
 * @format
 */

import React, { forwardRef } from "react";

interface IconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const TopMenu = forwardRef(
  ({ width = 25, height = 25, fill, ...restProps }: IconProps, ref) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.96924 4.729C3.96924 4.17672 4.41695 3.729 4.96924 3.729H7.96924C8.52152 3.729 8.96924 4.17672 8.96924 4.729V7.729C8.96924 8.28129 8.52152 8.729 7.96924 8.729H4.96924C4.41695 8.729 3.96924 8.28129 3.96924 7.729V4.729ZM3.96924 11.229C3.96924 10.6767 4.41695 10.229 4.96924 10.229H7.96924C8.52152 10.229 8.96924 10.6767 8.96924 11.229V14.229C8.96924 14.7813 8.52152 15.229 7.96924 15.229H4.96924C4.41695 15.229 3.96924 14.7813 3.96924 14.229V11.229ZM4.96924 16.729C4.41695 16.729 3.96924 17.1767 3.96924 17.729V20.729C3.96924 21.2813 4.41695 21.729 4.96924 21.729H7.96924C8.52152 21.729 8.96924 21.2813 8.96924 20.729V17.729C8.96924 17.1767 8.52152 16.729 7.96924 16.729H4.96924ZM10.4692 11.229C10.4692 10.6767 10.917 10.229 11.4692 10.229H14.4692C15.0215 10.229 15.4692 10.6767 15.4692 11.229V14.229C15.4692 14.7813 15.0215 15.229 14.4692 15.229H11.4692C10.917 15.229 10.4692 14.7813 10.4692 14.229V11.229ZM11.4692 3.729C10.917 3.729 10.4692 4.17672 10.4692 4.729V7.729C10.4692 8.28129 10.917 8.729 11.4692 8.729H14.4692C15.0215 8.729 15.4692 8.28129 15.4692 7.729V4.729C15.4692 4.17672 15.0215 3.729 14.4692 3.729H11.4692ZM16.9692 11.229C16.9692 10.6767 17.417 10.229 17.9692 10.229H20.9692C21.5215 10.229 21.9692 10.6767 21.9692 11.229V14.229C21.9692 14.7813 21.5215 15.229 20.9692 15.229H17.9692C17.417 15.229 16.9692 14.7813 16.9692 14.229V11.229ZM11.4692 16.729C10.917 16.729 10.4692 17.1767 10.4692 17.729V20.729C10.4692 21.2813 10.917 21.729 11.4692 21.729H14.4692C15.0215 21.729 15.4692 21.2813 15.4692 20.729V17.729C15.4692 17.1767 15.0215 16.729 14.4692 16.729H11.4692ZM16.9692 4.729C16.9692 4.17672 17.417 3.729 17.9692 3.729H20.9692C21.5215 3.729 21.9692 4.17672 21.9692 4.729V7.729C21.9692 8.28129 21.5215 8.729 20.9692 8.729H17.9692C17.417 8.729 16.9692 8.28129 16.9692 7.729V4.729ZM17.9692 16.729C17.417 16.729 16.9692 17.1767 16.9692 17.729V20.729C16.9692 21.2813 17.417 21.729 17.9692 21.729H20.9692C21.5215 21.729 21.9692 21.2813 21.9692 20.729V17.729C21.9692 17.1767 21.5215 16.729 20.9692 16.729H17.9692Z"
        fill="white"
      />
    </svg>
  )
);

export default TopMenu;
